import sectionFreestyleOrderPolicyCss from '../css-snippets/section-freestyle-order-policy';

const html = `
<style>${sectionFreestyleOrderPolicyCss}</style>
 <div data-attribute="content">
  <h2 style="text-align: center;">
    <strong>
      Freestyle Order Policy
    </strong>   
  </h2>
 </div>
`;
export default html;
